import { interpolateColor, useAnimatedStyle, useDerivedValue, withSpring } from 'react-native-reanimated';
import { useTheme } from 'styled-components/native';
import { springConfig } from '~/constants/animations';
import { PressableAnimationsProps } from '~/types/animations';

export interface ActionButtonAnimationsRenderPropValue {
    buttonAnimationStyles: {
        backgroundColor: string;
    };
}

export interface ActionButtonAnimationsProps extends PressableAnimationsProps<ActionButtonAnimationsRenderPropValue> {
    active?: boolean;
}

export const ActionButtonAnimation = ({ progress, active, children }: ActionButtonAnimationsProps) => {
    const theme = useTheme();

    const backgroundProgress = useDerivedValue(() => withSpring(active ? 1 : progress, springConfig.default));

    const currentBackground: Record<string, string> = {
        default: 'transparent',
        hovered: theme.palette.opacity['08'].rgba,
        pressed: theme.palette.opacity['08'].rgba,
    };

    const buttonAnimationStyles = useAnimatedStyle(() => {
        return {
            backgroundColor: interpolateColor(
                backgroundProgress.value,
                [0, 1, 2],
                [currentBackground.default, currentBackground.hovered, currentBackground.pressed],
            ),
        };
    });

    return children({ buttonAnimationStyles });
};
